import { Context, Order, Customer } from "@squareup/sq-addons-web-sdk";
import { v4 as uuidv4 } from "uuid";

export const CONTEXT: Context = {
  configurations: {
    environmentUrl: "http://localhost:3000",
  },
  device: { hasScanner: true, id: "27" },
  employee: { id: "04" },
};

export const ORDER: Order = {
  id: uuidv4(),
  createdAt: "2023-07-03 18:58:41 +0000",
  state: "OPEN",
  totalDiscountMoney: {
    amount: BigInt(0),
    currency: "USD",
  },
  totalMoney: {
    amount: BigInt(5000),
    currency: "USD",
  },
  totalTaxMoney: {
    amount: BigInt(0),
    currency: "USD",
  },
  lineItems: [
    {
      itemType: "ITEM",
      totalMoney: {
        amount: BigInt(5000),
        currency: "USD",
      },
      catalogVersion: BigInt(1683668969588),
      totalServiceChargeMoney: {
        amount: BigInt(0),
        currency: "USD",
      },
      totalDiscountMoney: {
        amount: BigInt(0),
        currency: "USD",
      },
      name: "Expensive Latte",
      catalogObjectId: "B7GSIKURFOEXI3EPF2VXMOFT",
      quantity: "1",
      grossSalesMoney: {
        amount: BigInt(5000),
        currency: "USD",
      },
      uid: "4BCA63F0-2D30-49DC-A1F1-DD1D7B840DA4",
      variationName: "Regular",
      variationTotalPriceMoney: {
        amount: BigInt(5000),
        currency: "USD",
      },
      totalTaxMoney: {
        amount: BigInt(0),
        currency: "USD",
      },
      basePriceMoney: {
        amount: BigInt(5000),
        currency: "USD",
      },
    },
    {
      itemType: "ITEM",
      totalMoney: {
        amount: BigInt(5000),
        currency: "USD",
      },
      catalogVersion: BigInt(1683668969588),
      totalServiceChargeMoney: {
        amount: BigInt(0),
        currency: "USD",
      },
      totalDiscountMoney: {
        amount: BigInt(0),
        currency: "USD",
      },
      name: "Modelo Latte",
      catalogObjectId: "B7GSIKURFOEXI3EPF2VXMOFT",
      quantity: "1",
      grossSalesMoney: {
        amount: BigInt(5000),
        currency: "USD",
      },
      uid: "4BCA63F0-2D30-49DC-A1F1-DD1D7B840DA6",
      variationName: "Regular",
      variationTotalPriceMoney: {
        amount: BigInt(5000),
        currency: "USD",
      },
      totalTaxMoney: {
        amount: BigInt(0),
        currency: "USD",
      },
      basePriceMoney: {
        amount: BigInt(5000),
        currency: "USD",
      },
    },
    {
      itemType: "ITEM",
      totalMoney: {
        amount: BigInt(10000),
        currency: "USD",
      },
      catalogVersion: BigInt(1683668969588),
      totalServiceChargeMoney: {
        amount: BigInt(0),
        currency: "USD",
      },
      totalDiscountMoney: {
        amount: BigInt(0),
        currency: "USD",
      },
      name: "Expensive 123",
      catalogObjectId: "B7GSIKURFOEXI3EPF2VXMOFT",
      quantity: "1",
      grossSalesMoney: {
        amount: BigInt(5000),
        currency: "USD",
      },
      uid: "4BCA63F0-2D30-49DC-A1F1-DD1D7B840DA5",
      variationName: "Regular",
      variationTotalPriceMoney: {
        amount: BigInt(5000),
        currency: "USD",
      },
      totalTaxMoney: {
        amount: BigInt(0),
        currency: "USD",
      },
      basePriceMoney: {
        amount: BigInt(5000),
        currency: "USD",
      },
    },
  ],
  source: {
    name: "Point of Sale",
  },
  locationId: "KB4GRB5WXP7K7",
  totalTipMoney: {
    amount: BigInt(0),
    currency: "USD",
  },
  totalServiceChargeMoney: {
    amount: BigInt(0),
    currency: "USD",
  },
  netAmounts: {
    totalMoney: {
      amount: BigInt(1300),
      currency: "USD",
    },
    tipMoney: {
      amount: BigInt(0),
      currency: "USD",
    },
    serviceChargeMoney: {
      amount: BigInt(0),
      currency: "USD",
    },
    taxMoney: {
      amount: BigInt(0),
      currency: "USD",
    },
    discountMoney: {
      amount: BigInt(0),
      currency: "USD",
    },
  },
  fulfillments: [
    {
      state: "PROPOSED",
      uid: "606D1625-A285-4219-9D40-9B0C3631C341",
      type: "SIMPLE",
    },
  ],
  netAmountDueMoney: {
    amount: BigInt(5000),
    currency: "USD",
  },
};

export const CUSTOMER: Customer = {
  address: {
    postalCode: "02482",
  },
  givenName: "Jude",
  familyName: "Edwards",
  birthday: "1980-01-01",
  emailAddress: "judeedwards@squareup.com",
  referenceId: "gbptJq",
  phoneNumber: "5104691554",
};
